<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">The Venging</h1>
<p class="author">Greg Bear</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?63ce74e3